import reviewReducer from './';

export default reviewReducer;
